import { render } from "./allNotifications.vue?vue&type=template&id=5a1dc707"
import script from "./allNotifications.vue?vue&type=script&lang=js"
export * from "./allNotifications.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./allNotifications.vue?vue&type=style&index=0&id=5a1dc707&lang=scss&module=true"
cssModules["$style"] = style0
import "./allNotifications.vue?vue&type=style&index=1&id=5a1dc707&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__